/*
# -----------------------------------------------------------------------------
# Component: accountsViewMixin.js
# Author: antonio.ramirez@pst.sg
# Created Date: 23/April/2019
# Comments: Responsible for all field and label for Accounts Transation Detail
# -----------------------------------------------------------------------------
*/
export const accountsViewMixin = {
  data() {
    return {
      accounts: {
        branch: '',
        documentNo: '',
        transactionDate: '',
        posted: '',
        accountNo: '',
        fundSuffix: '',
        department: '',
        transactionGroup: '',
        gstRegistrationNo: '',
        gstIOStatusRate: '',
        currency: '',
        rbcTran: '',
        netAmount: '',
        localNetAmount: '',
        outstandingBalance: '',
        localOutstandingBalance: '',
        debitAmount: '',
        debitGST: '',
        instalmentNo: '',
        dueDate: null,
        createdBy: '',
        createdProgram: '',
        lastModifiedBy: '',
        modifiedProgram: '',
        locAmtAe: '',
        zeroBal: false,
        void: 'Void',
        voidAe: false,
        voidReason: '',
        voidDate: undefined,
        fund: '',
        acctNoSfx: '',
        gstStat: '',
        inOutGST: '',
        gstRate: '',
        branchDesc: '',
        bankDesc: '',
        acctNoDesc: ''
      },
      accountsLabel: {
        transactionsDetails: 'View Account Transactions Details',
        branch: 'Branch',
        documentNoLbl: 'Document No. (Auto/Entered)',
        transactionDate: 'Transaction Date',
        posted: 'Posted',
        accountNo: 'Account No.',
        fundSuffix: 'Fund , Suffix',
        department: 'Department',
        transactionGroup: 'Transaction Group',
        gstRegistrationNo: 'GST Registration No.',
        gstIOStatusRate: 'GST IO, Status, Rate',
        currency: 'Currency',
        rbcTran: 'RBC Transaction',
        netAmount: 'Net Amount',
        localNetAmount: 'Local Net Amount',
        outstandingBalance: 'Outstanding Balance',
        localOutstandingBalance: 'Local Outstanding Balance',
        debitAmount: 'Debit Amount',
        debitGST: 'Debit GST',
        instalmentNo: 'Instalment No.',
        dueDate: 'Due Date',
        createdBy: 'Created By',
        createdProgram: 'Created Program',
        lastModifiedBy: 'Last Modified By',
        modifiedProgram: 'Modified Program',
        zeroBal: '',
        voidReason: 'Void Reason',
        voidDate: 'Void Date'
      },
      matchedDet: {
        lastMatchedDate: '',
        lastBaseTranType: '',
        bchMatchDocNo: '',
        bchMatchLater: ''
      },
      bankDet: {
        bankNo: '',
        bankAcctCurr: '',
        bankOrigAmt: '',
        bankCharges: '',
        bankLocTotal: '',
        bankTranDate: '',
        paymentMethod: '',
        creditCardNo: '',
        payerBank: '',
        payerCheqNo: '',
        cheqNo: '',
        printCheq: '',
        cashBookNo: '',
        payinSlipNo: '',
        drawerName: '',
        glInterface: '',
        acctPeriod: '',
        bankLocTotalAe: null,
        bankOrigAmtAe: ''
      },
      policyDet: {
        polType: '',
        polNo: '',
        commDate: '',
        coverNoteNo: '',
        premium: '',
        premiumGST: '',
        commission: '',
        commissionGST: '',
        commissionGSTStatRate: '',
        commissionStatus: '',
        fee: '',
        stamp: '',
        tax: '',
        vehicleRegNo: '',
        insuredRef: '',
        insuredName: '',
        cessionNo: '',
        cessionEndtNo: '',
        cedant: '',
        cessionPolNo: '',
        cedantCessionNo: '',
        claimNo: '',
        claimAmt: '',
        claimGST: ''
      },
      documentDet: {
        documentTo: '',
        toPrint: '',
        addressedTo: '',
        mailingAddress: '',
        remarks: '',
        statementRef: '',
        debitNote: '',
        bankList: '',
        bankPayinList: '',
        branchDocumentList: '',
        taxInvoiceNo: '',
        printTaxInvoice: '',
        theirTaxInvoiceNo: '',
        tranType2: ''
      },
      glTransDet: {
        journal: '',
        itemNo: '',
        glAcctNo: '',
        gstStatRate: '',
        gstAmt: '',
        origCurrAmt: '',
        locAmt: '',
        transDate: '',
        acctPeriod: '',
        glInterface: '',
        batchNo: '',
        createdBy: '',
        modifiedBy: '',
        docBrn: '',
        docFund: '',
        docNo: '',
        docAcctSfx: '',
        acctNo: '',
        rbcAcctNo: '',
        polNo: '',
        clmNo: '',
        comDate: '',
        expDate: '',
        holdGLUpd: '',
        glAc1: '',
        glAc2: '',
        glAc3: '',
        glAc4: '',
        glAc5: '',
        glAc6: '',
        glAc7: '',
        glAc8: '',
        glAc9: '',
        glAc10: '',
        glSys: undefined,
        glApplnInt: undefined,
        project: '',
        glDept: null,
        gstStat: '',
        gstRate: ''
      },
      glTransHdrDet: {
        docNo: '',
        glJrnl: '',
        acctNo: '',
        tranDate: '',
        acctPeriod: '',
        polOrClm: ''
      },
      matchDet: {
        journal: '',
        acctNo: '',
        matchedDate: '',
        baseTranReceipt: '',
        baseTranReceiptLbl: '',
        contBranch: '',
        selTranPayment: '',
        selTranPaymentLbl: '',
        branch: '',
        matchedAmt: '',
        matchedLocAmt: '',
        createdBy: '',
        mchListPrtd: false
      },
      comVoucherDet: {
        comType: '',
        voucherNo: '',
        comPayRecover: '',
        comDel: '',
        comMatchedBy: '',
        bAcctNo: '',
        oAcctNo: '',
        bBranch: '',
        oBranch: '',
        bTranType: '',
        oTranType: '',
        bDocNo: '',
        oDocNo: '',
        bFund: '',
        oFund: '',
        bSuffix: '',
        oSuffix: '',
        bComm: '',
        oComm: '',
        bOutStdBal: '',
        oOutStdBal: '',
        createdBy: '',
        modifiedBy: '',
        polNo: '',
        curr: '',
        lastMatchedDate: '',
        tranDate: '',
        prem: '',
        netAmt: '',
        insRefNoName: ''
      },
      gstIOOptions: [
        { value: 'B', label: '' },
        { value: 'I', label: 'I - Input' },
        { value: 'O', label: 'O - Output' }
      ]
    }
  },
  methods: {
  }
}
